module.exports = __webpack_public_path__ + "img/Difarmer-nosotros.008f151b.png";